import { render, staticRenderFns } from "./button_solo.vue?vue&type=template&id=e5998aec"
import script from "./button_solo.vue?vue&type=script&lang=js"
export * from "./button_solo.vue?vue&type=script&lang=js"
import style0 from "./button_solo.vue?vue&type=style&index=0&id=e5998aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports